module.exports = __webpack_public_path__ + "/img/SOIC-SOP-Labeled-5qAirt.svg";